import root from 'window-or-global';
import {createClassLogger, Logger} from '../../utils/Logging';
import {AccountLinkingBridge, AccountLinkingResponseCallback} from '../accountLinkingBridge';

const logger: Logger = createClassLogger('AccountLinkingBridge:Mock');

const accountLinkingMock: AccountLinkingBridge = {
    linkAccount: async (): Promise<void> => {
        logger.info('linkAccount', 'MOCKED');
        root.location.href = root.clientEnvConfig && root.clientEnvConfig.EPIC_UBI_LINK_URL;
    },
    registerResponseCallback: async (callback: AccountLinkingResponseCallback): Promise<void> => {
        logger.info(
            'registerResponseCallback',
            'MOCKED, use __accountLinkingResponseCallback to trigger callback'
        );
        root.__accountLinkingResponseCallback = callback;
    }
};

export default accountLinkingMock;
